import { keyframes, styled, theme, uiCommon } from '../../lib/stitches'

const pulseG = keyframes({
  '0%': {
    fill: theme.colors.ui_neutral03
  },
  '70%': {
    transform: 'scale(1.02)',
    fill: theme.colors.ui_neutral07
  }
})

const pulseMid = keyframes({
  '0%': {
    fill: theme.colors.ui_neutral03
  },
  '70%': {
    fill: theme.colors.ui_neutral07
  }
})

export const StyledGrafbaseAnimated = styled('div', {
  svg: {
    overflow: 'visible',
    path: {
      fill: theme.colors.ui_neutral03
    }
  },

  '& #grafbase-animated-layer-g': {
    transformOrigin: 'center',
    animation: `${pulseG} 1s ${uiCommon.transitions.authenticMotion} -0.6s infinite`
  },
  '& #grafbase-animated-layer-mid': {
    transformOrigin: 'center',
    animation: `${pulseMid} 1s ${uiCommon.transitions.authenticMotion} -0.7s infinite`
  },
  '& #grafbase-animated-layer-bottom': {
    transformOrigin: 'center',
    animation: `${pulseMid} 1s ${uiCommon.transitions.authenticMotion} -0.8s infinite`
  },

  variants: {
    size: {
      small: {
        height: 16,
        width: 16
      },
      medium: {
        height: 24,
        width: 24
      },
      large: {
        height: 36,
        width: 36
      }
    },
    speed: {
      default: {
        '& #grafbase-animated-layer-g, & #grafbase-animated-layer-mid, & #grafbase-animated-layer-bottom':
          {
            animationDuration: '1s'
          }
      },
      slower: {
        '& #grafbase-animated-layer-g, & #grafbase-animated-layer-mid, & #grafbase-animated-layer-bottom':
          {
            animationDuration: '1.25s'
          }
      },
      faster: {
        '& #grafbase-animated-layer-g, & #grafbase-animated-layer-mid, & #grafbase-animated-layer-bottom':
          {
            animationDuration: '0.75s'
          }
      }
    }
  }
})
